"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.MAXIMUM_NUMBER_OF_BLOCKS_FOR_TRANSACTION = exports.chunks = exports.getUnixTs = exports.sleep = void 0;
async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
function getUnixTs() {
    return new Date().getTime() / 1000;
}
exports.getUnixTs = getUnixTs;
function chunks(array, size) {
    const result = [];
    let i, j;
    for (i = 0, j = array.length; i < j; i += size) {
        result.push(array.slice(i, i + size));
    }
    return result;
}
exports.chunks = chunks;
exports.MAXIMUM_NUMBER_OF_BLOCKS_FOR_TRANSACTION = 152;
class Logger {
    constructor({ logFlowInfo = false }) {
        this.logFlowInfo = false;
        this.logFlowInfo = logFlowInfo;
    }
    log(message, ...optionalParams) {
        if (this.logFlowInfo) {
            console.log(message, ...optionalParams);
        }
    }
}
exports.Logger = Logger;
